import React from 'react'
import { getImageSrc } from './util/getImageUrl'

export default (props) => {
  const image = getImageSrc(props.image, 600) || ''
  const style = {
    backgroundImage: `url(${image})`,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  }
  return <div className='background-image' style={style} />
}



// WEBPACK FOOTER //
// ./src/BG.js